export default __webpack_public_path__ + "static/media/KellyFillion.7bf4701f.jpg";